import MenuDropdown from "../../../../components/dropdown/MenuDropdown/MenuDropdown";
import {useSession} from "../../../../redux/Reducers/AuthReducer";
import {NavLink, useNavigate} from "react-router-dom";
import {getUri} from "../../../../utils/utils";
import Icon from "../../../../components/Icon/Icon";


export default function ProfileBlock({className, ...props}) {
    const {session, authActions} = useSession();
    const navigate = useNavigate()
    return (
        <MenuDropdown


            button={<img
                className={`${className} h-10 w-10 cursor-pointer rounded-full`}
                src={getUri(session?.profile?.dp_uri?.file)}
                alt="Elon Musk"
            />}
            classNames={"py-2 top-8 -left-[200px] w-max"}
        >
            <div
                className="flex w-56 flex-col  justify-start rounded-lg bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-darkTheme-700 dark:text-white dark:shadow-none">
                <div className="p-4">

                    <div className="flex items-center gap-2">
                        <img
                            className={`${className} h-12 w-12 cursor-pointer rounded-full`}
                            src={getUri(session?.profile?.dp_uri?.file)}
                            alt="Elon Musk"
                        />
                        <div className={"flex justify-start flex-col"}>
                            <p className="text-sm text-center whitespace-nowrap font-bold text-navy-700 dark:text-white">
                                {session?.profile?.full_name?.length > 15 ? session?.profile?.full_name?.substring(0, 15) + "..." : session?.profile?.full_name}
                            </p>
                            <p className="pl-2 text-xxs text-gray-400 text-center whitespace-nowrap font-thin  ">
                                {session?.profile?.email}
                            </p>
                        </div>
                    </div>

                </div>
                <div className="h-px w-full bg-gray-200  dark:bg-white/20 "/>

                <div className="flex relative flex-col text-xs font-normal  text-gray-500 ">
                    <NavLink
                        to={"/settings"}
                        className="p-2 flex gap-2 items-center"
                    >
                        <Icon name={"settings"} className={"w-4 h-4"}/>
                         <p>
                             Settings
                         </p>
                    </NavLink>
                    <div className="h-px w-full bg-gray-200  dark:bg-white/20 "/>
                    {/*<NavLink*/}
                    {/*    to={""}*/}
                    {/*    className="p-2 flex gap-2 items-center"*/}
                    {/*>*/}
                    {/*    <Icon name={"share"} className={"w-4 h-4"}/>*/}
                    {/*    <p>*/}
                    {/*        Refer a Friend*/}
                    {/*    </p>*/}
                    {/*</NavLink>*/}
                    {/*<div className="h-px w-full bg-gray-200  dark:bg-white/20 "/>*/}
                    {/*<NavLink*/}
                    {/*    to={""}*/}
                    {/*    className="p-2 flex gap-2 items-center"*/}
                    {/*>*/}
                    {/*    <Icon name={"help"} className={"w-4 h-4"}/>*/}
                    {/*    <p>*/}
                    {/*       Support*/}
                    {/*    </p>*/}
                    {/*</NavLink>*/}
                    <div className="h-px w-full bg-gray-200  dark:bg-white/20 "/>

                    <div onClick={()=>{
                        authActions.clearSession();
                    }} className={"px-2 p-1 w-1/2 m-auto mt-4  mb-4 justify-center items-center text-gray-900 font-semibold cursor-pointer flex gap-2  border-[1px] rounded-full border-gray-300"}>

                        <Icon name={"logout"} className={"w-4 h-4"}/>
                        <p>
                            Log Out
                        </p>
                    </div>

                </div>


            </div>
        </MenuDropdown>

    )
}